import { getGlobal } from "@/functions/getGlobal";
import { consultant_helper } from "@/helpers/consultant_helper";
import { jobs_helper } from "@/helpers/jobs_helper";
import ConsultantProfile from "@/components/ConsultantProfile"; 
import Jobs from "@/components/Jobs";
import SeoHead from "@/components/SeoHead";


export default function ConsultantPage({ consultant, all_jobs }) {
  const global = getGlobal();

  return (
    <>
      <main>
        <SeoHead
            page_name={`${consultant?.name} - Omega`}
            description={`Get in touch with ${consultant?.name} today via email, phone or on Linkedin.`}
            canonical_link={`https://www.omegaresource.co.uk/consultants/${consultant?.url_slug}/`}
          />
        <ConsultantProfile consultant={consultant}/>
        <Jobs highlight="Jobs" color_variant="turquoise" items={all_jobs} title={`Jobs posted by ${consultant?.name}`}></Jobs>
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const consultant = consultant_helper.find(url_slug);
  // const all_jobs = jobs_helper.fetch().filter((job) => job.consultant_name?.toLowerCase() === consultant.name?.toLowerCase());
  
  const all_jobs = jobs_helper.fetch().filter((job) =>
    job.categories?.some((category) =>
      category.name === 'Consultants' &&
      category.values.some((consultantValue) =>
        consultantValue.name.toLowerCase() === consultant.name?.toLowerCase()
      )
    )
  );  

  return {
    props: {
      consultant,
      all_jobs
    },
  };
}

export async function getStaticPaths() {
  return { paths: consultant_helper.toPaths(), fallback: false };
}
